import { render, staticRenderFns } from "./Theme2Wrapper.vue?vue&type=template&id=1b4b57bc&scoped=true&"
import script from "./Theme2Wrapper.vue?vue&type=script&lang=js&"
export * from "./Theme2Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Wrapper.vue?vue&type=style&index=0&id=1b4b57bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b57bc",
  null
  
)

export default component.exports